// Layout sezione Integrazioni: API keys, webhook, docs API, kiosk, retention.
// Sprint 7.

import { NavLink, Outlet } from 'react-router';
import { RuleBicolor } from '@audiq/ui';

const TABS = [
  { to: '/integrations/api-keys', label: 'API Keys' },
  { to: '/integrations/webhooks', label: 'Webhook' },
  { to: '/integrations/kiosk', label: 'Kiosk' },
  { to: '/integrations/retention', label: 'Retention' },
  { to: '/integrations/api-docs', label: 'Docs API' },
];

export function IntegrationsLayout() {
  return (
    <div>
      <div className="mono mb-2" style={{ color: 'var(--mute)' }}>
        Integrazioni
      </div>
      <h2 className="serif text-3xl mb-1" style={{ color: 'var(--ink)' }}>
        Integrazioni e privacy
      </h2>
      <p className="text-sm mb-4" style={{ color: 'var(--mute)' }}>
        API esterna v1, webhook outbound, modalità kiosk, retention dati.
      </p>
      <RuleBicolor className="my-4" />

      <div
        className="flex gap-1 mb-6 overflow-x-auto rounded-md p-1"
        style={{ background: 'var(--soft)' }}
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `inline-block whitespace-nowrap rounded-md px-4 py-2 text-sm transition`
            }
            style={({ isActive }) => ({
              background: isActive ? 'var(--paper)' : 'transparent',
              color: isActive ? 'var(--primary-2)' : 'var(--ink)',
              fontWeight: isActive ? 600 : 400,
              boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
            })}
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
